import { Spinner } from "@material-tailwind/react";
import { FC } from "react";
import AlertModalDelete from "components/AlertModal/AlertModalDelete";
import PaymentStatus from "components/Payment/PaymentStatus";
import ReservationDetails from "components/Payment/ReservationDetails";
import ErrorDisplay from "components/Payment/ErrorDisplay";
import { usePaymentConfirmation } from "hooks/usePaymentConfirmation";
import "components/Payment/PaymentAnimations.css";

export interface PaymentConfirmationPageProps {
  className?: string;
}

const PaymentConfirmationPage: FC<PaymentConfirmationPageProps> = ({ className = "" }) => {
  const {
    showSpinner,
    loading,
    isLoading,
    showModal,
    detailState,
    messageState,
    handleExploreLocationsClick,
    handleSubmit,
    handleCancel,
    handleClick,
    setShowModal,
  } = usePaymentConfirmation();

  const renderContent = () => {
    if (!detailState?.Location) {
      return null;
    }

    return (
      <>
        <AlertModalDelete
          open={showModal}
          handleDelete={() => handleCancel()}
          handleClose={() => setShowModal(false)}
          message="Êtes-vous sûr(e) de vouloir annuler votre réservation ?"
          alertText="Annulation de Réservation"
        />
        <div className="space-y-8 stagger-animation">
          <div className="animate-slide-up">
            <PaymentStatus
              messageState={messageState || ""}
              onConfirm={handleSubmit}
              onExploreLocations={handleExploreLocationsClick}
              onCancel={handleClick}
              isConfirmLoading={isLoading}
              isCancelLoading={loading}
            />
          </div>

          <div className="animate-slide-up animation-delay-150">
            <ReservationDetails
              location={{
                title: detailState.Location.title || undefined,
                city: detailState.Location.city || undefined,
                region: detailState.Location.region,
                surface: detailState.Location.surface,
                images: detailState.Location.images || undefined,
              }}
              reservation={{
                selectedDate: detailState.selectedDate || undefined,
                startHour: detailState.startHour || undefined,
                endHour: detailState.endHour || undefined,
                visitor: detailState.visitor || undefined,
                price: detailState.price || undefined,
              }}
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <div
      className={`nc-PaymentConfirmationPage ${className} min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-800 dark:to-blue-900`}
      data-nc-id="PaymentConfirmationPage"
    >
      <main className="container py-12 lg:py-20">
        {showSpinner ? (
          <div className="flex flex-col items-center justify-center min-h-[60vh] space-y-6">
            <div className="relative">
              <div className="w-20 h-20 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
              <div className="absolute inset-0 w-20 h-20 border-4 border-transparent border-r-blue-400 rounded-full animate-spin animation-delay-75"></div>
            </div>
            <div className="text-center space-y-2">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                Chargement de votre réservation
              </h3>
              <p className="text-gray-600 dark:text-gray-400">Veuillez patienter quelques instants...</p>
            </div>
          </div>
        ) : (
          <div className="max-w-5xl mx-auto animate-fade-in">
            {/* Page Header */}
            <div className="text-center mb-12">
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-4">
                Confirmation de réservation
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
                Consultez les détails de votre réservation et finalisez votre demande
              </p>
            </div>

            {messageState === "no reservation with this reference" ? (
              <ErrorDisplay onExploreLocations={handleExploreLocationsClick} />
            ) : (
              <div className="space-y-8">{renderContent()}</div>
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default PaymentConfirmationPage;
